
<li>
  <article class="lg:py-10">
    <div v-if="objectRecord">
      <a
        :href="`/online-collection/${objectRecord.objectRecordId}`"
        class="block space-y-4"
      >
        <div class="pb-3:2 relative">
          <div class="inset-0 p-ogs">
            <img
              class="h-full w-full max-w-md object-contain"
              :alt="objectRecord.name"
              :src="objectRecord.largeImageUrl"
            />
          </div>
        </div>
        <h3 class="text-lg lg:text-xl">
          {{ objectRecord.truncatedName }}
        </h3>
      </a>
    </div>
  </article>
</li>
